<template>
  <infinite-loader
  v-if="loading"
  color="white"
  size="30"/>
  <v-row
  v-else
  justify="space-between">
    <v-col
    xl="8"
    md="7"
    class="d-flex justify-space-between px-16">
      <nav-menu
      :btn="partRequestMenu"
      />
      <nav-menu
      :btn="remoteSupportMenu"
      />
      <nav-menu
      :btn="repairMenu"
      />
    </v-col>
    <v-col
    xl="4"
    md="5"
    class="d-flex justify-md-end justify-lg-start">
      <!-- <nav-menu
      :btn="reportMenu"
      /> -->
      <nav-menu
      :btn="usersManagementMenu"
      />
      <nav-menu
      :btn="settingsMenu"
      />
      <nav-menu
      :btn="profileMenu"
      />
    </v-col>
  </v-row>
</template>

<script>
// import NavBtn from '@/components/navigation/NavBtn'
import NavMenu from '@/components/navigation/NavMenu'
import InfiniteLoader from '@/components/common/InfiniteLoader'
import { execHttpRequestThrowable } from '@/services/http'
import { removeUserToken } from '@/services/authService'
import { DynamicNotifier } from '@/utils/DynamicNotifier.js'
import { logout } from '@/repositories/authRepo'
import { routeFromRoot } from '@/services/routeService'
import { buildForAdmin, findTheHighlightPage } from "@/data/navigator/menus"
export default {
  components: {
    // NavBtn,
    NavMenu,
    InfiniteLoader
  },
  data() {
    return {
      partRequestMenu: null,
      remoteSupportMenu: null,
      repairMenu: null,
      // reportMenu: null,
      usersManagementMenu: null,
      settingsMenu: null,
      profileMenu: null,
      loading: true
    }
  },
  watch: {
    '$route.path': {
      handler() {
        if (!this.loading) this.startSearchingForSelectedPage()
      },
      immediate: true
    }
  },
  methods: {
    startSearchingForSelectedPage() {
      findTheHighlightPage([
        this.partRequestMenu,
        this.remoteSupportMenu,
        this.repairMenu,
        // this.reportMenu,
        this.usersManagementMenu,
        this.settingsMenu,
        this.profileMenu
      ],
      this.$route)
    }
  },
  mounted() {
    this.loading = true
    const { partRequestMenu, remoteSupportMenu, repairMenu, usersManagementMenu, settingsMenu, profileMenu } = buildForAdmin() //reportMenu

    //NOTE: This is logout btn.
    profileMenu.children[1].action = async () => {
      await execHttpRequestThrowable(logout)
      removeUserToken()
      DynamicNotifier.notify('signInEvent')
      routeFromRoot('login')
    }

    this.partRequestMenu = partRequestMenu
    this.remoteSupportMenu = remoteSupportMenu
    this.repairMenu = repairMenu
    // this.reportMenu = reportMenu
    this.usersManagementMenu = usersManagementMenu
    this.settingsMenu = settingsMenu
    this.profileMenu = profileMenu

    this.loading = false

    this.startSearchingForSelectedPage()
  }
}
</script>

<style>

</style>